import { type ReactNode } from "react";
import { clinic } from "@/mocks/clinic";

/**
 * WEB予約CTA。
 * 外部予約ページ（KIREIPASS）を新しいタブで開く。
 * 表示文言は呼び出し側から渡し、URLは clinic.webReserveUrl に一元化する。
 * ※ LINE相談のリンクは対象外（LineButton コンポーネントが clinic.lineUrl を一元管理）。
 */
export function ReserveButton({
  children,
  className = "",
  onClick,
}: {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}) {
  return (
    <a
      href={clinic.webReserveUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={className}
    >
      {children}
    </a>
  );
}